import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import React, { useState, type JSX } from 'react';
import { EuroFormat } from '../common/inputFormats';
import { SPACING_BETWEEN_FORM_FIELDS } from '../common/spacings';
import { dialogActions } from './Dialog';

type Props = {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly onSave: (wert?: number | null) => void;
  readonly text: string;
  readonly titel: string;
  readonly saveButtonText: string;
  readonly maxWert: number | undefined;
};

export function WertDialog({ open, onClose, onSave: onEdit, text, titel, saveButtonText, maxWert }: Props): JSX.Element {
  const [wert, setWert] = useState(0);

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="wertHinzufuegen">
      <DialogTitle id="wertHinzufuegen">{titel}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
        <Grid container spacing={SPACING_BETWEEN_FORM_FIELDS}>
          <Grid size={12}>
            <TextField
              variant="standard"
              label="Brutto Gutschriftswert"
              value={wert}
              helperText={maxWert ? `Maximaler Gutschriftswert: € ${maxWert.toFixed(2).replace('.', ',')}` : ''}
              error={maxWert !== undefined && wert > maxWert}
              onChange={(event) => setWert(Number(event.target.value))}
              fullWidth
              data-testid="gutschrift-bruttowert"
              InputProps={{
                inputComponent: EuroFormat,
                endAdornment: <InputAdornment position="end">€</InputAdornment>
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={dialogActions}>
        <Button autoFocus onClick={onClose} variant="contained" color="secondary">
          Abbrechen
        </Button>
        <Button onClick={() => onEdit(wert * 100)} variant="contained" color="primary" disabled={wert === 0 || (maxWert !== undefined && wert > maxWert)}>
          {saveButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
